import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ComparacaoPage from '@/pages/comparacao/page';
import EstrategiasPage from '@/pages/estrategias/page';
import StrategyDetailPage from '@/pages/estrategias/StrategyDetailPage';
import ArtigosPage from '@/pages/artigos/page';
import ArticleDetailPage from '@/pages/artigos/ArticleDetailPage';
import SobrePage from '@/pages/sobre/page';
import ContactosPage from '@/pages/contactos/page';
import TradingLivePage from '@/pages/tradinglive/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/comparacao', element: <ComparacaoPage /> },
  { path: '/estrategias', element: <EstrategiasPage /> },
  { path: '/estrategias/:id', element: <StrategyDetailPage /> },
  { path: '/artigos', element: <ArtigosPage /> },
  { path: '/artigos/:id', element: <ArticleDetailPage /> },
  { path: '/sobre', element: <SobrePage /> },
  { path: '/contactos', element: <ContactosPage /> },
  { path: '/trading-live', element: <TradingLivePage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
